// extracted by mini-css-extract-plugin
export default {"rating":"IN-z","numberOfStars":"JN-z","count":"KN-z","barGraphSpacing":"LN-z","barGraph":"MN-z"};